"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoldingGroupType = exports.MainGroupTypeEnum = void 0;
/**
 * 主账户分组枚举
 */
var MainGroupTypeEnum;
(function (MainGroupTypeEnum) {
    /**
     * 跟单机器人（feed流里的）
     */
    MainGroupTypeEnum["copy_trade"] = "copy_trade";
    /**
     * 机器人
     */
    MainGroupTypeEnum["trading_bot"] = "trading_bot";
    /**
     * 现货（交易资产）
     */
    MainGroupTypeEnum["spot"] = "spot";
    /**
     * 质押
     */
    MainGroupTypeEnum["staking"] = "staking";
    /**
     * 存币生息
     */
    MainGroupTypeEnum["lending"] = "lending";
    /*
     * 派币宝
     */
    MainGroupTypeEnum["shark_fin"] = "shark_fin";
    /** 预留仓位 */
    MainGroupTypeEnum["position"] = "position";
    /** 简易合约 */
    MainGroupTypeEnum["futures_lite"] = "futures_lite";
})(MainGroupTypeEnum || (exports.MainGroupTypeEnum = MainGroupTypeEnum = {}));
/**
 * 持币分组类型
 * bot_account 持币资产
 */
var HoldingGroupType;
(function (HoldingGroupType) {
    /**
     * 主账户
     */
    HoldingGroupType["bot_account"] = "bot_account";
    /**合约账户 */
    HoldingGroupType["futures_account"] = "trader_account";
})(HoldingGroupType || (exports.HoldingGroupType = HoldingGroupType = {}));
